import app from 'flarum/forum/app';
export default function loadPortal() {
  // Используем штатный request Flarum: он добавляет базовый URL и единообразно обрабатывает ошибки.
  return app.request({
    method: 'GET',
    url: `${app.forum.attribute('apiUrl')}/devconnect/portal`
  });
}
flarum.reg.add('devconnect-portal', 'forum/service/portalApi', loadPortal);